import { h } from 'preact'
import globals from '../../utils/globals'
import EmptyPage from '../empty-page/EmptyPage'

type Props = {
  code: number
}

const errors: { [code: number]: {
    header: string,
    text: string | JSX.Element
  }} = {
    400: {
      header: 'You\'ve just sent a bad request',
      text: 'There was a problem with your request. Please try again.'
    },
    403: {
      header: 'You shall not pass',
      text: 'We\'re sorry, but you do not have permission to access this page.'
    },
    404: {
      header: 'Whoops! Page not found',
      text: <div>
        <p>Sorry, the page you are looking for might have been removed, or is temporarily unavailable.</p>
        <p>Did you come here through our website?</p>
        <p>Please let us know by e-mail: <a href='mailto:support@insided.com'>support@insided.com</a></p>
      </div>
    },
    500: {
      header: 'Oops! There\'s an internal server error.',
      text: 'Don\'t worry, it\'s not you - it\'s us. Sorry about that.\n Please try again in a few minutes.'
    }
  }

const ErrorPage = ({ code }: Props) => {
  const error = errors[code]

  if (!error) return 'Sorry, this page is not available'

  return <EmptyPage
    fullHeight
    img_src={`${globals('basePath')}images/errors/${code}.png`}
    button={{
      link: '/',
      text: 'Back to homepage'
    }}
    {...error}
  />
}

export default ErrorPage
